import { useEffect, useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import { Toaster } from "react-hot-toast";
import ClientMainLayout from "layouts/ClientMainLayout";
import ClientProtectedRoute from "components/ClientProtectedRoute";
import ClientLogin from "pages/ClientLogin";
import ClientLogout from "pages/ClientLogout";
import ClientContractView from "pages/ClientContractView";
import ClientContactView from "pages/ClientContactView";
import ClientTicketView from "pages/ClientTicketView";
import clientRoutes from "routes";
import { isClientLoggedIn } from "utils/clientSession";

export default function App() {
  const { pathname } = useLocation();
  const [, setSessionTick] = useState(0);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement!.scrollTop = 0;
  }, [pathname]);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setSessionTick((value) => value + 1);
    }, 30000);
    return () => window.clearInterval(timer);
  }, []);

  const layoutRoutes = clientRoutes.filter(
    (route) => route.route && route.key !== "logout"
  );

  const loggedInHome = isClientLoggedIn() ? "/profile" : "/login";

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        width: "100%",
        maxWidth: "100%",
        overflowX: "hidden",
      }}
    >
      <Routes>
        <Route path="/login" element={<ClientLogin />} />
        <Route path="/logout" element={<ClientLogout />} />
        <Route path="/" element={<Navigate to={loggedInHome} replace />} />

        {layoutRoutes.map((route) => (
          <Route
            key={route.key}
            path={route.route}
            element={
              <ClientProtectedRoute>
                <ClientMainLayout routes={clientRoutes}>{route.component}</ClientMainLayout>
              </ClientProtectedRoute>
            }
          />
        ))}

        <Route
          path="/contracts/view/:contractId"
          element={
            <ClientProtectedRoute>
              <ClientMainLayout routes={clientRoutes}>
                <ClientContractView />
              </ClientMainLayout>
            </ClientProtectedRoute>
          }
        />

        <Route
          path="/customers/contacts/:contactId"
          element={
            <ClientProtectedRoute>
              <ClientMainLayout routes={clientRoutes}>
                <ClientContactView />
              </ClientMainLayout>
            </ClientProtectedRoute>
          }
        />

        <Route
          path="/tickets/view/:ticketId"
          element={
            <ClientProtectedRoute>
              <ClientMainLayout routes={clientRoutes}>
                <ClientTicketView />
              </ClientMainLayout>
            </ClientProtectedRoute>
          }
        />

        <Route path="*" element={<Navigate to={loggedInHome} replace />} />
      </Routes>
      <Toaster position="top-right" />
    </Box>
  );
}
